/* CAREMA SFY Outfit Explorer v1.2 - theme 59, isolated homepage block.
   Data: window.CaremaSFY (assets/sfy-looks-core.js, unchanged): load() + sequence(looks, occasion) in its editorial order, no limit;
   a sold-out cover stays visible with "Sold Out" (same rule as the hub). Each look opens /pages/looks/<handle>; VIEW ALL uses the canonical key.
   Motion: the homepage SFY carousel engine (snippets/sfy-occasion-nav.liquid, featured variant, Paso 3.21) ported 1:1 into this file -
   same edge-to-edge layout from the current visual scales (constant gap, no overlap), same release trajectory (POS), same size hand-over (PROF),
   same drag rules (rigid strip, one card per gesture). Additions: a bounded mode when the looks cannot loop without a visible wrap,
   a static single look, desktop tokens, keyboard / trackpad / arrows, and a rebuild when the occasion changes. No autoplay.
   Deep links /#styled-for-you/<occasion>/<look handle> (Hero buttons, other pages) open that occasion with that look centred.
   v1.1: the gap may depend on the pair (centre-neighbour --cx-gap, neighbour-neighbour --cx-gap-side), continuous in the scales;
   SHOP THE LOOK always points to the look that is visually the protagonist (largest card, the one whose name is shown). */
(function () {
  'use strict';

  var KEYS = ['brunch', 'professional', 'weekend', 'evening', 'travel', 'everyday'];
  var FRAME = 2 / 3, LOCK = 8, WINDOW = 100, MAX_AGE = 100, PROJECT = 300, RUBBER = 0.35, NEAR = 3, SWAP_MS = 220, INTRO_MS = 900, READY_MS = 700;
  var PROF = { dOut: 100, wOut: 620, cOut: 0, dIn: 100, wIn: 620, cIn: 0 }, LAB0 = 0.5, LAB1 = 0.9;
  var POS = { tau1: 52, D: 1850, k: 2.0, c: 0.85, aMax: 0.6, minD: 500, ref: 0.82, quick: 0.8 };
  var rmq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function reduced() { return !!rmq.matches; }
  function smooth(a) { return a * a * (3 - 2 * a); }
  function clamp(v, lo, hi) { return v < lo ? lo : (v > hi ? hi : v); }
  function posE(tau) { var s, a, b; tau = tau < 0 ? 0 : (tau > 1 ? 1 : tau); s = tau + POS.c * tau * (1 - tau); a = Math.pow(s, POS.k); b = Math.pow(1 - s, POS.k); return a / (a + b); }
  function posQ(an, tm) { return an.a0 * (1 - Math.exp(-tm / POS.tau1)) + (1 - an.a0) * posE(tm / an.D); }
  function labelAt(P) { return smooth(clamp((P - LAB0) / (LAB1 - LAB0), 0, 1)); }
  /* v1.2 desktop framing (4:5). Approved per-look decisions for the 110 reviewed looks: entries below, every other reviewed look = c50 (cover 50% 50%).
     Looks outside the reviewed set use the provisional rule: ratio < 0.64 -> contain, otherwise c50 (to be reviewed visually). Phones keep their own rule. */
  var DESK_FIT = {"soft-pink-skirt-look":"c85","althea-polka-edit":"c85","red-pink-denim-look":"c85","blue-polka-midi-look":"c85","aqua-blouse-look":"contain","blue-green-colorblock-look":"c85","chocolate-polka-midi-look":"c85","green-polka-dot-look":"c85","luxury-arrival-edit":"c50","everyday-elevated":"contain","denim-refined-the-carema-edit":"contain","carema-look-fxplpbh5":"contain","pavira-contrast-suit-look":"contain"};
  var REVIEWED = '|carema-look-fxplpbh5|denim-refined-the-carema-edit|pink-striped-pants-look|soft-pink-skirt-look|navy-embroidered-dress-look|look-brunch-ease|vexira-blouse-edit|althea-polka-edit|white-jacket-taupe-look|red-pink-denim-look|blue-polka-midi-look|aqua-blouse-look|croissant-pink-denim-look|blush-burgundy-dot-look|blue-green-colorblock-look|chocolate-polka-midi-look|yellow-geometric-shorts-look|green-polka-dot-look|color-print-set-edit|red-stripe-set-edit|gingham-skirt-look|white-sculpted-blouse-look|burgundy-floral-edit|floral-halter-set-edit|pastel-floral-dress-edit|pink-polka-dot-brunch-look|rainy-stripe-look|pink-coral-stripe-look|white-bow-blouse-edit|olive-stripe-shorts-edit|pink-lime-look|plaid-skirt-look|ciao-bella-bubble-skirt-look|chocolate-polka-pants-look|pink-burgundy-stripe-dress-edit|blue-bubble-skirt-look|polka-dot-set-look|effortless-contrast|pavira-contrast-suit-look|effortless-tailored-power|coral-cape-look|camel-blazer-look|monochrome-polka-dot-look|cobalt-gray-power-look|chocolate-pink-power-look|ivory-vest-edit|navy-pink-power-look|black-white-power-look|red-tailored-edit|ivory-bow-blouse-edit|ivory-suit-edit|black-monochrome-edit|navy-taupe-power-edit|blue-shirt-power-look|monochrome-power-look|lavender-chocolate-look|black-gold-power-look|purple-midi-skirt-edit|magenta-blazer-look|soft-pink-vest-look|navy-stripe-power-look|kiora-polka-dot-edit|ovia-red-edit|pink-mini-set-edit|light-blue-jumpsuit-look|red-toile-jumpsuit-look|denim-scarf-set-look|white-halter-bubble-set-look|brown-jacket-weekend-look|mediterranean-print-look|leopard-overall-look|pastel-floral-lace-dress-look|evening-structure|red-wide-leg-pants-edit|violet-tie-blouse-edit|floral-noir-edit|leopard-noir-look|white-asymmetric-dress-look|black-bow-evening-look|burgundy-satin-denim-edit|burgundy-texture-power-look|burgundy-lace-denim-look|luxury-arrival-edit|seaside-pink-look|the-look-of-the-month-april|everyday-elevated|red-cape-denim-look|polka-dot-pants-look|brown-red-dress-look|striped-pants-look|red-top-denim-look|blush-taupe-elegance-look|carema-look-7a7myw7c|indigo-denim-pants-look|cobalt-denim-look|botanical-denim-look|camel-look|striped-polo-look|striped-button-top-look|striped-bow-blouse-look|ivory-burgundy-look|denim-on-denim-look|denim-trench-look|dusty-blue-white-look|taupe-polka-dot-skirt-look|white-khaki-city-look|black-white-stripe-look|sand-shirt-dress-look|indigo-denim-set-look|cream-stripe-mini-dress-edit|';
  var NEW_MIN = 0.64;
  /* Alternative desktop photo (sfy_occasion card_image, read by the section Liquid): only for the approved cover look of that occasion, only >=1025px. */
  var ALT_LOOK = { brunch: 'carema-look-fxplpbh5', professional: 'pavira-contrast-suit-look' }, ALT_FIT = { brunch: 'c85', professional: 'c50' };
  /* Brunch: the card_image is also the photo of the original SFY BRUNCH card on phones, so it is used at every width (phones keep their own framing rule). */
  var ALT_ALL = { brunch: true };
  function deskFit(handle) {
    if (Object.prototype.hasOwnProperty.call(DESK_FIT, handle)) return DESK_FIT[handle];
    return REVIEWED.indexOf('|' + handle + '|') >= 0 ? 'c50' : '';
  }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function sized(src, w) { try { var u = new URL(src, window.location.origin); u.searchParams.set('width', String(w)); return u.toString(); } catch (e) { return src; } }

  function Engine(o) {
    var root = o.root, vp = o.viewport, nameEl = o.name, prevB = o.prev, nextB = o.next, onProt = o.onProtagonist || function () {};
    var cards = [], n = 0, items = [], on = false, loop = false, p = 0, cw = 0, gap = 16, gapS = 16, prot = -1, side = 0.72, f1 = 0, LO = 0, HI = 0, lastW = 0, ci = -1;
    var lastT = [], lastO = [], xs = [], ss = [], os = [], sc = [];
    var anim = null, rafId = 0, ticking = false;
    var pid = null, sx = 0, sy = 0, refX = 0, p0 = 0, base = 0, locked = false, ignored = false, wasAnim = false, suppress = false, samples = [];
    var wT = 0, wAcc = 0, wHold = false, pending = false;

    function mod(i) { return loop ? ((i % n) + n) % n : i; }
    function centreOf(pv) { var r = Math.round(pv); return loop ? mod(r) : clamp(r, 0, n - 1); }
    function cssReady() { var v = window.getComputedStyle(root).getPropertyValue('--cx-card-w'); return !!(v && v.replace(/\s/g, '')); }
    function measure() {
      var s = parseFloat(window.getComputedStyle(root).getPropertyValue('--cx-side'));
      side = s > 0 && s < 1 ? s : 0.72;
      var probe = document.createElement('div');
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;height:0;width:var(--cx-card-w)';
      vp.appendChild(probe);
      var w = probe.getBoundingClientRect().width;
      probe.style.width = 'var(--cx-gap)';
      var g = probe.getBoundingClientRect().width;
      probe.style.width = 'var(--cx-gap-side, var(--cx-gap))';
      var gs = probe.getBoundingClientRect().width;
      vp.removeChild(probe);
      gap = g > 0 ? g : 16;
      gapS = gs > 0 ? gs : gap;
      cw = w > 0 ? w : 0;
      f1 = 0.5 * (1 + side) * cw + gap;
    }
    /* gap between two neighbouring cards: --cx-gap next to the protagonist, --cx-gap-side between two neighbours, linear (so continuous) in between */
    function gp(a, b) { return gapS === gap ? gap : gap + (gapS - gap) * clamp((1 + side - a - b) / (1 - side), 0, 1); }
    function restScales(h) { var a = [], i, c = centreOf(h); for (i = 0; i < n; i++) a[i] = i === c ? 1 : side; return a; }
    function allSide() { var a = [], i; for (i = 0; i < n; i++) a[i] = side; return a; }
    /* Pure layout from the CURRENT visual scales S (engine of the homepage carousel): centres edge to edge, gap constant by construction,
       camera at fraction f between the centres of cards k and k+1. Bounded mode lays the cards out in order, without wrapping. */
    function layout(pv, S) {
      var k, f, d, i, c = [], cam;
      if (n === 1) { xs[0] = 0; ss[0] = S[0]; os[0] = 1; return; }
      if (loop) {
        k = Math.floor(pv); f = pv - k;
        c[0 - LO] = 0;
        for (d = 1; d <= HI; d++) c[d - LO] = c[d - 1 - LO] + (S[mod(k + d - 1)] + S[mod(k + d)]) * cw / 2 + gp(S[mod(k + d - 1)], S[mod(k + d)]);
        for (d = -1; d >= LO; d--) c[d - LO] = c[d + 1 - LO] - (S[mod(k + d)] + S[mod(k + d + 1)]) * cw / 2 - gp(S[mod(k + d)], S[mod(k + d + 1)]);
        cam = c[0 - LO] + (c[1 - LO] - c[0 - LO]) * f;
        for (d = LO; d <= HI; d++) { i = mod(k + d); xs[i] = c[d - LO] - cam; ss[i] = S[i]; os[i] = labelAt(clamp((S[i] - side) / (1 - side), 0, 1)); }
      } else {
        k = clamp(Math.floor(pv), 0, n - 2); f = pv - k;
        c[k] = 0;
        for (i = k + 1; i < n; i++) c[i] = c[i - 1] + (S[i - 1] + S[i]) * cw / 2 + gp(S[i - 1], S[i]);
        for (i = k - 1; i >= 0; i--) c[i] = c[i + 1] - (S[i] + S[i + 1]) * cw / 2 - gp(S[i], S[i + 1]);
        cam = c[k] + (c[k + 1] - c[k]) * f;
        for (i = 0; i < n; i++) { xs[i] = c[i] - cam; ss[i] = S[i]; os[i] = labelAt(clamp((S[i] - side) / (1 - side), 0, 1)); }
      }
    }
    /* Loop only when the card that wraps around is always fully outside the viewport (no visible duplicate or jump). */
    function wrapsOffscreen(S) {
      var a, b, i, half = vp.clientWidth / 2 + 2;
      layout(0.999, S); a = { x: xs.slice(), s: ss.slice() };
      layout(1.001, S); b = { x: xs.slice(), s: ss.slice() };
      for (i = 0; i < n; i++) {
        if (Math.abs(a.x[i] - b.x[i]) > 4 && (Math.abs(a.x[i]) - a.s[i] * cw / 2 <= half || Math.abs(b.x[i]) - b.s[i] * cw / 2 <= half)) return false;
      }
      return true;
    }
    function decideLoop() {
      loop = false;
      if (n < 3 || !(cw > 0)) return;
      loop = true; LO = -Math.floor((n - 1) / 2); HI = LO + n - 1;
      var keep = p; p = 0;
      if (!(wrapsOffscreen(restScales(0)) && wrapsOffscreen(allSide()))) loop = false;
      p = keep;
    }
    function render() {
      layout(p, sc);
      var c = centreOf(p), rm = reduced(), i, t, op;
      for (i = 0; i < n; i++) {
        t = 'translate3d(' + xs[i].toFixed(2) + 'px,0,0) scale(' + ss[i].toFixed(4) + ')';
        if (lastT[i] !== t) { cards[i].style.transform = t; lastT[i] = t; }
        op = (rm ? (i === c ? 1 : 0) : os[i]).toFixed(3);
        if (items[i] && lastO[i] !== op) { items[i].style.opacity = op; lastO[i] = op; }
      }
      if (c !== ci) { ci = c; onCentre(c); }
      /* protagonist = the largest card right now (ties: the settled centre); it is the look whose name is visible */
      var best = c, bs = -1;
      for (i = 0; i < n; i++) { if (ss[i] > bs + 1e-6 || (Math.abs(ss[i] - bs) <= 1e-6 && i === c)) { bs = ss[i]; best = i; } }
      if (rm) best = c;
      if (best !== prot) { prot = best; onProt(prot); }
    }
    function dist(i, c) { var d = Math.abs(i - c); return loop ? Math.min(d, n - d) : d; }
    function hydrate(img) {
      if (!img || !img.hasAttribute('data-src')) return;
      var src = img.previousElementSibling;
      if (src && src.tagName === 'SOURCE' && src.hasAttribute('data-srcset')) { src.setAttribute('srcset', src.getAttribute('data-srcset')); src.removeAttribute('data-srcset'); }
      img.setAttribute('sizes', img.getAttribute('data-sizes') || '100vw');
      img.setAttribute('srcset', img.getAttribute('data-srcset') || '');
      img.setAttribute('src', img.getAttribute('data-src'));
      img.removeAttribute('data-src');
    }
    function onCentre(c) {
      var i;
      for (i = 0; i < n; i++) {
        var a = i === c;
        cards[i].tabIndex = a ? 0 : -1;
        if (a) cards[i].setAttribute('aria-current', 'true'); else cards[i].removeAttribute('aria-current');
        if (dist(i, c) <= NEAR) hydrate(cards[i].querySelector('img'));
      }
      arrows();
    }
    function arrows() {
      var many = on && n > 1;
      prevB.hidden = nextB.hidden = !many;
      if (!many) return;
      var t = anim ? anim.target : Math.round(p);
      prevB.disabled = !loop && t <= 0;
      nextB.disabled = !loop && t >= n - 1;
    }
    function paint() { ticking = false; if (on) render(); }
    function schedule() { if (!ticking) { ticking = true; window.requestAnimationFrame(paint); } }
    function stopAnim() { anim = null; if (rafId) { window.cancelAnimationFrame(rafId); rafId = 0; } }
    function scaleAt(a, tm, i) {
      var d = a.sTo[i] - a.sFrom[i];
      if (d === 0) return a.sTo[i];
      var dec = d < 0, tau = clamp((tm - (dec ? a.dOut : a.dIn)) / (dec ? a.wOut : a.wIn), 0, 1), t2 = tau * tau, t3 = t2 * tau, c = dec ? a.cOut : a.cIn;
      return clamp(a.sFrom[i] + d * smooth(tau + c * tau * (1 - tau)) + a.m[i] * (t3 - 2 * t2 + tau), side, 1);
    }
    function scaleVel() {
      var v = [], i, tm, lo, hi;
      if (!anim) { for (i = 0; i < n; i++) v[i] = 0; return v; }
      tm = window.performance.now() - anim.t0; lo = Math.max(0, tm - 4); hi = tm + 4;
      for (i = 0; i < n; i++) v[i] = (scaleAt(anim, hi, i) - scaleAt(anim, lo, i)) / (hi - lo);
      return v;
    }
    function settle(target) { return loop ? mod(target) : target; }
    function startAnim(target, v0, quick, fromP, fixedD) {
      if (!loop) target = clamp(target, 0, n - 1);
      var sv0 = scaleVel();
      stopAnim();
      var delta = target - p, s1 = restScales(target), rs = restScales(Math.round(p)), i, d, M, u, dS = 0, dev = 0;
      for (i = 0; i < n; i++) { dS = Math.max(dS, Math.abs(sc[i] - s1[i])); dev = Math.max(dev, Math.abs(sc[i] - rs[i])); }
      if ((Math.abs(delta) < 0.0005 && dS < 0.002) || reduced()) { p = settle(target); sc = s1; render(); arrows(); return; }
      var dir = delta >= 0 ? 1 : -1, ad = Math.abs(delta), s0 = v0 * dir;
      var D = fixedD || Math.min(POS.D, POS.minD + (POS.D - POS.minD) * Math.sqrt(ad / POS.ref)) * (quick ? POS.quick : 1);
      var a0 = s0 > 0 && ad > 0 ? clamp(s0 * POS.tau1 / ad, 0, POS.aMax) : 0;
      var q0 = fromP === undefined || target === fromP ? 0 : clamp((p - fromP) / (target - fromP), 0, 1);
      var fresh = dev < 0.02, cap = 0.5 * D, dOut = fresh ? PROF.dOut * (1 - q0) : 0, dIn = fresh ? PROF.dIn * (1 - q0) : 0;
      var wOut = clamp(cap - dOut, 120, PROF.wOut), wIn = clamp(cap - dIn, 120, PROF.wIn), m = [];
      for (i = 0; i < n; i++) {
        d = s1[i] - sc[i]; u = d < 0 ? -1 : 1;
        M = sv0[i] * (d < 0 ? wOut : wIn);
        m[i] = d === 0 ? 0 : u * clamp(u * M, -0.3 * Math.abs(d), 3 * Math.abs(d));
      }
      anim = { from: p, dir: dir, ad: ad, a0: a0, D: D, t0: window.performance.now(), target: target, sFrom: sc.slice(), sTo: s1, dOut: dOut, wOut: wOut, cOut: PROF.cOut, dIn: dIn, wIn: wIn, cIn: PROF.cIn, m: m };
      arrows();
      rafId = window.requestAnimationFrame(tick);
    }
    function tick(ts) {
      rafId = 0;
      if (!anim) return;
      var tau = (ts - anim.t0) / anim.D, i;
      if (tau >= 1) { p = settle(anim.target); sc = anim.sTo.slice(); anim = null; render(); arrows(); return; }
      var tm = Math.max(0, ts - anim.t0);
      p = anim.from + anim.dir * anim.ad * posQ(anim, tm);
      for (i = 0; i < n; i++) sc[i] = scaleAt(anim, tm, i);
      render();
      rafId = window.requestAnimationFrame(tick);
    }
    function animVelocity() {
      if (!anim) return 0;
      var tm = window.performance.now() - anim.t0, lo = Math.max(0, tm - 4), hi = tm + 4;
      return anim.dir * anim.ad * (posQ(anim, hi) - posQ(anim, lo)) / (hi - lo);
    }
    function stepBy(dir) {
      if (!on || n < 2) return false;
      var t = (anim ? anim.target : Math.round(p)) + dir;
      if (!loop && (t < 0 || t > n - 1)) return false;
      startAnim(t, animVelocity(), true);
      return true;
    }
    function toCard(i) {
      if (!on || n < 2) return;
      if (anim && settle(anim.target) === i) return;
      var b = anim ? anim.target : Math.round(p), d = i - b;
      if (loop) d -= n * Math.round(d / n);
      startAnim(b + d, animVelocity(), true);
    }
    function isCentre(i) { return !anim && centreOf(p) === i && Math.abs(p - Math.round(p)) < 0.001; }
    function velocity(now) {
      var b = samples[samples.length - 1], k = 0;
      if (!b) return 0;
      while (k < samples.length - 1 && b.t - samples[k].t > WINDOW) k++;
      var a = samples[k], dt = b.t - a.t, age = now - b.t;
      if (dt < 8 || age > MAX_AGE) return 0;
      return (b.p - a.p) / dt * (age < 40 ? 1 : (MAX_AGE - age) / (MAX_AGE - 40));
    }
    function rubber(raw) {
      if (loop) return raw;
      if (raw < 0) return raw * RUBBER;
      if (raw > n - 1) return n - 1 + (raw - (n - 1)) * RUBBER;
      return raw;
    }
    function onDown(e) {
      if (!on || n < 2 || pid !== null) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      pid = e.pointerId; sx = e.clientX; sy = e.clientY;
      locked = false; ignored = false; suppress = false; samples = [];
      wasAnim = !!anim;
      stopAnim();
    }
    function onMove(e) {
      if (e.pointerId !== pid || ignored) return;
      if (!locked) {
        var dx = e.clientX - sx, dy = e.clientY - sy;
        if (Math.max(Math.abs(dx), Math.abs(dy)) < LOCK) return;
        if (Math.abs(dx) > Math.abs(dy)) {
          locked = true; refX = e.clientX; p0 = p; base = Math.round(p);
          samples = [{ t: e.timeStamp, p: p }];
          try { vp.setPointerCapture(pid); } catch (err) {}
        } else {
          ignored = true;
        }
        return;
      }
      var raw = p0 - (e.clientX - refX) / f1;
      if (raw > base + 1) { raw = base + 1; p0 = raw; refX = e.clientX; }
      else if (raw < base - 1) { raw = base - 1; p0 = raw; refX = e.clientX; }
      p = rubber(raw);
      samples.push({ t: e.timeStamp, p: p });
      while (samples.length > 2 && e.timeStamp - samples[0].t > WINDOW) samples.shift();
      schedule();
    }
    function onEnd(e) {
      if (e.pointerId !== pid) return;
      var was = locked;
      pid = null; locked = false;
      try { if (vp.hasPointerCapture && vp.hasPointerCapture(e.pointerId)) vp.releasePointerCapture(e.pointerId); } catch (err) {}
      if (was) {
        var v = velocity(e.timeStamp), r = Math.round(p);
        var t = Math.round(p + clamp(v * PROJECT, -1, 1));
        t = clamp(t, Math.min(base - 1, r), Math.max(base + 1, r));
        if (!loop) t = clamp(t, 0, n - 1);
        suppress = true;
        startAnim(t, v, false, base);
      } else {
        if (wasAnim) suppress = true;
        if (Math.abs(p - Math.round(p)) > 0.0005) startAnim(Math.round(p), 0, true);
      }
    }
    function buildNames(labels) {
      while (nameEl.firstChild) nameEl.removeChild(nameEl.firstChild);
      items = labels.map(function (l) {
        var s = document.createElement('span');
        s.className = 'carema-sfy-explorer__name-item';
        s.textContent = l;
        nameEl.appendChild(s);
        return s;
      });
      lastO = [];
    }
    function hydrateAll() { cards.forEach(function (c) { hydrate(c.querySelector('img')); }); }
    function stopEngine() {
      stopAnim();
      pid = null; locked = false; ignored = false;
      cards.forEach(function (c) { c.style.transform = ''; c.tabIndex = 0; c.removeAttribute('aria-current'); });
      lastT = []; lastO = [];
      root.classList.remove('is-engine', 'is-multi', 'is-loop');
      prevB.hidden = nextB.hidden = true;
      on = false;
      hydrateAll();
    }
    function build(intro) {
      if (!n) return false;
      if (!cssReady() || !window.PointerEvent) { stopEngine(); return false; }
      root.classList.add('is-engine');
      measure();
      if (!(cw > 0)) { stopEngine(); return false; }
      decideLoop();
      root.classList.toggle('is-loop', loop);
      root.classList.toggle('is-multi', n > 1);
      p = clamp(Math.round(p), loop ? -Infinity : 0, loop ? Infinity : n - 1);
      if (loop) p = mod(p);
      on = true; lastW = vp.clientWidth; lastT = []; lastO = []; ci = -1;
      pending = intro && n > 1 && !reduced();
      sc = pending ? allSide() : restScales(p);
      render();
      arrows();
      return true;
    }
    /* After an occasion change the strip appears with every look at its neighbour size and the first look grows into the centre once the strip is visible. */
    function play() { if (!pending) return; pending = false; if (on && n > 1) startAnim(p, 0, true, undefined, INTRO_MS); }
    function setCards(els, labels, intro, start) {
      stopAnim(); pending = false;
      cards = els; n = els.length; p = start > 0 && start < els.length ? start : 0; ci = -1; prot = -1; xs = []; ss = []; os = []; lastT = []; lastO = [];
      buildNames(labels);
      if (!n) { on = false; prevB.hidden = nextB.hidden = true; return; }
      if (!build(intro)) hydrateAll();
    }
    function resize() {
      if (!n) return;
      if (!on) { build(false); return; }
      var prevCw = cw;
      measure();
      if (vp.clientWidth === lastW && Math.abs(cw - prevCw) < 0.5) return;
      var c = centreOf(anim ? anim.target : p);
      stopAnim(); p = c;
      decideLoop();
      root.classList.toggle('is-loop', loop);
      sc = restScales(p); lastW = vp.clientWidth; lastT = []; ci = -1; render(); arrows();
    }

    prevB.addEventListener('click', function () { stepBy(-1); });
    nextB.addEventListener('click', function () { stepBy(1); });
    vp.addEventListener('pointerdown', onDown);
    vp.addEventListener('pointermove', onMove);
    vp.addEventListener('pointerup', onEnd);
    vp.addEventListener('pointercancel', onEnd);
    vp.addEventListener('lostpointercapture', function (e) { if (e.target === vp) onEnd(e); });
    vp.addEventListener('dragstart', function (e) { if (on) e.preventDefault(); });
    vp.addEventListener('scroll', function () { if (on && vp.scrollLeft !== 0) vp.scrollLeft = 0; });
    vp.addEventListener('click', function (e) {
      if (!on) return;
      if (suppress && e.detail !== 0) { e.preventDefault(); e.stopPropagation(); suppress = false; return; }
      if (e.detail === 0) return;
      var c = e.target && e.target.closest ? e.target.closest('.carema-sfy-explorer__look') : null, i = cards.indexOf(c);
      if (i < 0 || isCentre(i)) return;
      e.preventDefault();
      e.stopPropagation();
      toCard(i);
    }, true);
    vp.addEventListener('focusin', function (e) {
      if (!on) return;
      var c = e.target && e.target.closest ? e.target.closest('.carema-sfy-explorer__look') : null, i = cards.indexOf(c);
      if (i >= 0 && i !== settle(anim ? anim.target : Math.round(p))) toCard(i);
    });
    vp.addEventListener('keydown', function (e) {
      if (!on || n < 2) return;
      var dir = e.key === 'ArrowRight' ? 1 : (e.key === 'ArrowLeft' ? -1 : 0);
      if (!dir) return;
      e.preventDefault();
      if (stepBy(dir)) { var t = settle(anim ? anim.target : Math.round(p)); if (cards[t]) cards[t].focus({ preventScroll: true }); }
    });
    /* Trackpad: one horizontal gesture = one look; the momentum tail of the same gesture is ignored. Vertical scrolling is untouched. */
    vp.addEventListener('wheel', function (e) {
      if (!on || n < 2) return;
      var dx = e.deltaX, dy = e.deltaY;
      if (e.shiftKey && !dx) { dx = dy; dy = 0; }
      if (Math.abs(dx) <= Math.abs(dy)) return;
      e.preventDefault();
      var now = e.timeStamp;
      if (now - wT > 180) { wAcc = 0; wHold = false; }
      wT = now;
      if (wHold) return;
      wAcc += dx;
      if (Math.abs(wAcc) >= 40) { stepBy(wAcc > 0 ? 1 : -1); wAcc = 0; wHold = true; }
    }, { passive: false });
    if (window.ResizeObserver) new window.ResizeObserver(function () { resize(); }).observe(vp);
    /* desktop card size also follows the viewport height and the theme's header height variable: re-measure when either changes */
    var rq = false;
    function resizeSoon() { if (rq) return; rq = true; window.requestAnimationFrame(function () { rq = false; resize(); }); }
    window.addEventListener('resize', resizeSoon);
    if (window.MutationObserver) new window.MutationObserver(resizeSoon).observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
    window.addEventListener('load', resize);

    function protagonist() { if (!n) return -1; if (!on) return 0; render(); return prot; }
    /* place look i in the centre at once (used for links that open a given look while the section is off screen) */
    function jump(i) {
      if (!on || i < 0 || i >= n) return;
      stopAnim(); pending = false; p = i; sc = restScales(p); lastT = []; ci = -1; render(); arrows();
    }
    return { setCards: setCards, play: play, jump: jump, step: stepBy, protagonist: protagonist, state: function () { return { on: on, loop: loop, n: n, p: p, centre: n ? centreOf(p) : -1, prot: prot, anim: !!anim, cw: cw, gap: gap, gapS: gapS, side: side }; } };
  }

  function srcset(url) { return [400, 600, 900, 1200].map(function (w) { return esc(sized(url, w)) + ' ' + w + 'w'; }).join(', '); }
  function card(item, i, total, alt) {
    var l = item.look, title = l.title || 'Complete look', soldOut = item.isCover && !item.purchasable;
    var img = '', useAlt = !!(alt && l.image), fitD = useAlt ? alt.fit : deskFit(l.handle);
    if (l.image) {
      var cls = fitD && fitD !== 'c50' ? ' class="cx-d-' + fitD + '"' : '', auto = fitD ? '' : ' data-cx-auto';
      img = '<img alt="' + esc(title) + '"' + cls + auto + ' width="600" height="900" decoding="async" data-src="' + esc(sized(l.image, 900)) + '" data-srcset="' + srcset(l.image) + '" data-sizes="(min-width: 1025px) 22vw, 70vw">';
      if (useAlt && alt.all) img = '<img alt="' + esc(title) + '"' + cls + ' width="600" height="900" decoding="async" data-src="' + esc(sized(alt.src, 900)) + '" data-srcset="' + srcset(alt.src) + '" data-sizes="(min-width: 1025px) 22vw, 70vw">';
      else if (useAlt) img = '<picture><source media="(min-width: 1025px)" data-srcset="' + srcset(alt.src) + '" sizes="22vw">' + img + '</picture>';
    }
    return '<a class="carema-sfy-explorer__look" href="/pages/looks/' + encodeURIComponent(l.handle) + '" data-cx-i="' + i + '" aria-label="' + esc(title + (soldOut ? ', sold out' : '') + ', look ' + (i + 1) + ' of ' + total) + '">' +
      '<div class="carema-sfy-explorer__photo">' + img + (soldOut ? '<span class="carema-sfy-explorer__badge">Sold Out</span>' : '') + '</div>' +
      '<p class="carema-sfy-explorer__title">' + esc(title) + '</p></a>';
  }
  /* phones keep the original rule (contain below 0.613) on the editorial photo; desktop framing is fixed per look (DESK_FIT), only unreviewed looks use the provisional ratio rule */
  function fit(img) {
    if (!img || !img.naturalWidth || !img.naturalHeight) return;
    var r = img.naturalWidth / img.naturalHeight, mob = !(window.matchMedia && window.matchMedia('(min-width: 1025px)').matches);
    if (mob || !img.closest('picture')) img.classList.toggle('is-contain', r < FRAME * 0.92);
    if (img.hasAttribute('data-cx-auto')) img.classList.toggle('cx-d-contain', r < NEW_MIN);
  }

  function setup(root) {
    if (root.__cx) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-occasion]'));
    var vp = root.querySelector('[data-cx-viewport]'), status = root.querySelector('[data-cx-status]'), empty = root.querySelector('[data-cx-empty]');
    var cta = root.querySelector('[data-cx-cta]'), nameEl = root.querySelector('[data-cx-name]'), panel = root.querySelector('[role="tabpanel"]');
    var prev = root.querySelector('[data-cx-dir="-1"]'), next = root.querySelector('[data-cx-dir="1"]');
    if (!tabs.length || !vp || !status || !empty || !cta || !nameEl || !prev || !next) return;
    root.__cx = true;
    var list = [], live = false;
    /* SHOP THE LOOK follows the protagonist; while an occasion is loading or swapping it is inert, so it can never open a look that is not on screen */
    function setCta(i) {
      var it = live && i >= 0 ? list[i] : null;
      if (!it) { cta.removeAttribute('href'); cta.setAttribute('aria-disabled', 'true'); cta.classList.add('is-off'); return; }
      var l = it.look, sold = it.isCover && !it.purchasable, label = sold ? 'VIEW THE LOOK' : 'SHOP THE LOOK', href = '/pages/looks/' + encodeURIComponent(l.handle);
      if (cta.getAttribute('href') !== href) cta.setAttribute('href', href);
      if (cta.textContent !== label) cta.textContent = label;
      cta.setAttribute('aria-label', (sold ? 'View the look: ' : 'Shop the look: ') + (l.title || 'Complete look') + (sold ? ' (sold out)' : ''));
      cta.classList.toggle('is-soldout', sold);
      cta.removeAttribute('aria-disabled'); cta.classList.remove('is-off');
    }
    var engine = Engine({ root: root, viewport: vp, name: nameEl, prev: prev, next: next, onProtagonist: setCta });
    var key = null, token = 0, first = true, swapT = 0;
    /* at the moment of the click the destination is re-read from the engine (same frame), so a click during a transition opens the look shown as protagonist */
    cta.addEventListener('click', function (e) {
      if (!live) { e.preventDefault(); return; }
      setCta(engine.protagonist());
      if (!cta.getAttribute('href')) e.preventDefault();
    });
    root.__cxEngine = engine;
    var alts = {};
    try { var aj = root.querySelector('[data-cx-alt]'); if (aj) alts = JSON.parse(aj.textContent || '{}') || {}; } catch (e) { alts = {}; }
    function altFor(it) {
      var src = alts[key];
      if (!it.isCover || !src || typeof src !== 'string' || ALT_LOOK[key] !== it.look.handle) return null;
      return { src: src, fit: ALT_FIT[key], all: !!ALT_ALL[key] };
    }

    vp.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG') fit(e.target); }, true);

    /* The photos on screen are decoded before the strip fades back in (at most READY_MS), so an occasion change never shows empty frames. */
    function ready(ms) {
      if (!ms) return Promise.resolve();
      var imgs = Array.prototype.slice.call(vp.querySelectorAll('img[src]'));
      var all = Promise.all(imgs.map(function (im) { return im.decode ? im.decode().catch(function () {}) : Promise.resolve(); }));
      return Promise.race([all, new Promise(function (r) { window.setTimeout(r, ms); })]);
    }
    function show(next, intro, start) {
      list = next;
      vp.innerHTML = list.map(function (it, i) { return card(it, i, list.length, altFor(it)); }).join('');
      var els = Array.prototype.slice.call(vp.querySelectorAll('.carema-sfy-explorer__look'));
      empty.hidden = !!list.length;
      live = true;
      engine.setCards(els, list.map(function (it) { return it.look.title || 'Complete look'; }), intro, start || 0);
      setCta(engine.protagonist());
    }
    function select(nextKey, userAction, silent) {
      if (KEYS.indexOf(nextKey) < 0 || nextKey === key) return;
      key = nextKey;
      var t = ++token;
      tabs.forEach(function (tab) {
        var a = tab.dataset.occasion === key;
        tab.classList.toggle('is-active', a);
        tab.setAttribute('aria-selected', String(a));
        tab.tabIndex = a ? 0 : -1;
        if (a && panel) panel.setAttribute('aria-labelledby', tab.id);
      });
      live = false; setCta(-1);
      var core = window.CaremaSFY;
      if (!core) { status.hidden = false; status.textContent = 'Looks are temporarily unavailable.'; return; }
      var fade = userAction && !first && !reduced() && !silent;
      if (fade) root.classList.add('is-swapping');
      var started = window.performance.now();
      core.load().then(function (looks) {
        if (t !== token) return;
        var seq = core.sequence(looks, key);
        var wait = fade ? Math.max(0, SWAP_MS - (window.performance.now() - started)) : 0;
        window.clearTimeout(swapT);
        swapT = window.setTimeout(function () {
          if (t !== token) return;
          status.hidden = true;
          var intro = !first && !silent, start = 0;
          if (want) { start = indexOfLook(seq, want); want = null; }
          show(seq, intro, start);
          first = false;
          ready(intro ? READY_MS : 0).then(function () {
            if (t !== token) return;
            root.classList.remove('is-swapping');
            window.requestAnimationFrame(function () { if (t === token) engine.play(); });
          });
        }, wait);
      }, function () {
        if (t !== token) return;
        root.classList.remove('is-swapping');
        status.hidden = false;
        status.textContent = 'Looks are temporarily unavailable.';
      });
    }
    /* Deep links to an occasion and one of its looks: /#styled-for-you/<occasion key>/<look handle> (the look is matched by its handle, never by
       its position). Used by the Hero buttons and valid from any page, email or ad. The page is never reloaded on Home, the URL is left as it is,
       the occasion is switched without animation (the section is off screen at that moment) and the page scrolls to the top of the section. */
    var want = null;
    function indexOfLook(seq, handle) {
      for (var i = 0; i < seq.length; i++) if (seq[i].look && seq[i].look.handle === handle) return i;
      return 0;
    }
    function parseLink(hash) {
      var m = /^#styled-for-you(?:\/([a-z]+)(?:\/([a-z0-9-]+))?)?\/?$/.exec(hash || '');
      if (!m) return null;
      if (m[1] && KEYS.indexOf(m[1]) < 0) return null;
      return { key: m[1] || null, look: m[2] || null };
    }
    function revealTab() {
      var nb = root.querySelector('.carema-sfy-explorer__navbar'), at = root.querySelector('.carema-sfy-explorer__tab.is-active');
      if (!nb || !at || nb.scrollWidth <= nb.clientWidth) return;
      var l = at.offsetLeft - nb.offsetLeft, r = l + at.offsetWidth;
      if (l < nb.scrollLeft) nb.scrollLeft = Math.max(0, l - 20); else if (r > nb.scrollLeft + nb.clientWidth) nb.scrollLeft = r - nb.clientWidth + 20;
    }
    function go(target, smooth, byKeyboard) {
      if (target.key && target.key !== key) { want = target.look; select(target.key, false, true); }
      else if (target.look) {
        if (live) { want = null; engine.jump(indexOfLook(list, target.look)); } else want = target.look;
      }
      revealTab();
      root.scrollIntoView({ block: 'start', behavior: smooth && !reduced() ? 'smooth' : 'auto' });
      if (byKeyboard) { var at = root.querySelector('.carema-sfy-explorer__tab.is-active'); if (at) at.focus({ preventScroll: true }); }
    }
    if (!window.__cxLinks) {
      window.__cxLinks = true;
      window.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
        if (!a || (a.target && a.target !== '_self')) return;
        var u; try { u = new URL(a.href, window.location.href); } catch (err) { return; }
        if (u.origin !== window.location.origin || u.pathname !== window.location.pathname) return;
        var t = parseLink(u.hash), r = document.querySelector('[data-carema-sfy-explorer]');
        if (!t || !r || !r.__cxGo) return;
        e.preventDefault();
        r.__cxGo(t, true, e.detail === 0);
      }, true);
    }
    root.__cxGo = go;
    var onLoad = parseLink(window.location.hash);
    window.addEventListener('hashchange', function () { var t = parseLink(window.location.hash); if (t && document.querySelector('[data-carema-sfy-explorer]') === root) go(t, true, false); });
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab.dataset.occasion, true); });
      tab.addEventListener('keydown', function (e) {
        var j = e.key === 'ArrowRight' ? (i + 1) % tabs.length : e.key === 'ArrowLeft' ? (i + tabs.length - 1) % tabs.length : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : -1;
        if (j < 0) return;
        e.preventDefault();
        tabs[j].focus();
        tabs[j].scrollIntoView({ block: 'nearest', inline: 'nearest' });
        select(tabs[j].dataset.occasion, true);
      });
    });
    if (onLoad && document.querySelector('[data-carema-sfy-explorer]') === root) {
      want = onLoad.look;
      select(onLoad.key || 'brunch', false, true);
      var land = function () { revealTab(); root.scrollIntoView({ block: 'start', behavior: 'auto' }); };
      window.requestAnimationFrame(land);
      if (document.readyState !== 'complete') {
        /* the second landing (after late images) only runs while the shopper has not touched, clicked, scrolled or typed yet */
        var used = false, evs = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
        var mark = function () { used = true; };
        evs.forEach(function (n) { window.addEventListener(n, mark, { capture: true, passive: true }); });
        window.addEventListener('load', function () {
          window.requestAnimationFrame(function () { evs.forEach(function (n) { window.removeEventListener(n, mark, true); }); if (!used) land(); });
        }, { once: true });
      }
    } else {
      select('brunch', false);
    }
  }
  function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-carema-sfy-explorer]'), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
